import { Toaster } from '@ui';
import type { ViewType, ViewConfig } from '../types';
import {
  darkPdfViewerTheme,
  lightPdfViewerTheme,
  generateStylesFromTheme,
} from '../themes';

export const open = (pdfItems: ViewType[], config?: ViewConfig) => {
  const theme =
    config?.theme === 'light' ? lightPdfViewerTheme : darkPdfViewerTheme;
  const defaultPageTitle = config?.defaultPageTitle || 'Document Preview';
  const messages = config?.messages || {};

  if (!pdfItems || pdfItems.length === 0) {
    Toaster.create({
      type: 'error',
      title: 'Error',
      message: messages.noPdfsError || 'No PDFs to open',
    });
    return;
  }

  let successCount = 0;
  let warningCount = 0;

  pdfItems.forEach(
    ({ url, pdfTitle, pageTitle = defaultPageTitle, details = [] }) => {
      if (!url) {
        warningCount++;
        return;
      }

      const styles = generateStylesFromTheme(theme);

      const detailsHtml = details
        .map(
          (d) =>
            `<div class="item"><div class="label">${String(d.label)}</div><div class="value">${
              typeof d.value === 'string' || typeof d.value === 'number'
                ? d.value
                : ''
            }</div></div>`,
        )
        .join('');

      const html = `<!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>${pageTitle} - ${pdfTitle}</title>
          <style>${styles}</style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <div class="title">${pageTitle}</div>
            </div>
            <div class="details">${detailsHtml}</div>
            <div class="frameWrap">
              <iframe src="${url}" allowfullscreen title="${pdfTitle}"></iframe>
            </div>
          </div>
        </body>
      </html>`;

      const blob = new Blob([html], { type: 'text/html' });
      const blobUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      successCount++;
    },
  );

  if (successCount > 0) {
    Toaster.create({
      type: 'success',
      title: messages.successTitle || 'Success',
      message: messages.successDescription
        ? messages.successDescription(successCount, warningCount)
        : `Opened ${successCount} PDF(s) in separate tabs${warningCount > 0 ? ` (${warningCount} with no files)` : ''}`,
    });
  }
};
